<div class="financial-simulator">
    <div class="summary">
        <!--
        <img [src]="'./assets/img/themes/' + brand + '/models/' + model + '_icon.png'" alt="" [style]="{ width: '100%', height: 'auto' }" />
        -->

        <!-- <img [src]="'./assets/img/themes/' + brand + '/models/' + model + '_icon.png'" alt="" class="logo_coche" /> -->

        <div *ngIf="data" class="highlights">
            <div class="highlights-name">
                <span class="label">{{ brand }} {{ model }}</span>
                <div class="value">
                    <span class="text-value">{{ data.price | number: '1.2-2' | myCurrencyPipe: '€' }}</span>
                </div>
            </div>
            <div class="highlights-rows">
                <div class="highlights-row">
                    <span *ngIf="selectedPaymentInsurance.code == 'INC'" class="label">{{ installmentAndInsuranceTotalGrossAmount | translate }}¹</span>
                    <span *ngIf="selectedPaymentInsurance.code != 'INC'" class="label">{{ installmentMonthlyGrossAmount | translate }}¹</span>
                    <div *ngIf="data" class="value">
                        <span *ngIf="selectedPaymentInsurance.code == 'INC'" class="text-value">{{ data.installmentAndInsuranceTotalGrossAmount | number: '1.2-2' | myCurrencyPipe: '€/mes' }}¹</span>
                        <span *ngIf="selectedPaymentInsurance.code != 'INC'" class="text-value">{{ data.installmentMonthlyGrossAmount | number: '1.2-2' | myCurrencyPipe: '€/mes' }}¹</span>
                    </div>
                </div>
                <div *ngIf="data" class="highlights-row">
                    <span class="label">
                        {{ downPaymentGrossAmount | translate }}
                    </span>
                    <div *ngIf="data" class="value">
                        <span class="text-value">{{ this.data.downPaymentGrossAmount | number: '1.2-2' | myCurrencyPipe: '€' }}</span>
                    </div>
                </div>
                <div class="highlights-row">
                    <span class="label">{{ duration | translate }}</span>
                    <div class="value">
                        <span class="text-value">{{ data.duration }} meses</span>
                    </div>
                </div>
            </div>
        </div>
<!-- | myDecimalPipe: 2   lo cambiamos  por | number: '1.2-2' porque no muestra los . con millares-->
        <div class="simulator-line"></div>

        <div *ngIf="data" class="simulator-rows">
            <div class="simulator-row">
                <span class="label">
                    {{ nominalRate | translate }} /
                    <span style="text-decoration: underline;">{{ aprcRate | translate }}</span>
                </span>
                <div class="value">
                    <span class="text-value">{{ data.nominalRate | number: '1.2-2' | myPercentPipe }}</span>
                    <span class="text-value"> / </span>
                    <span class="text-value" style="text-decoration: underline;">
                        {{ data.aprcRate | number: '1.2-2' | myPercentPipe }}
                    </span>
                </div>
            </div>
            <div class="simulator-row">
                <span class="label">{{ amountFinanced | translate }}</span>
                <div *ngIf="data"class="value">
                    <span class="text-value">{{ data.amountFinanced | number: '1.2-2' | myCurrencyPipe: '€' }}²</span>
                </div>
            </div>
            <div class="simulator-row">
                <span class="label">{{ totalInterestGrossAmount | translate }}</span>
                <div *ngIf="data" class="value">
                    <span class="text-value">{{ data.totalInterestGrossAmount | number: '1.2-2' | myCurrencyPipe: '€' }}</span>
                </div>
            </div>
            <div class="simulator-row">
                <span class="label">{{ totalCreditCost | translate }}</span>
                <div class="value">
                    <span *ngIf="selectedPaymentInsurance.code == 'INC'" class="text-value">{{ data.totalCreditCostInsurance | number: '1.2-2' | myCurrencyPipe: '€' }}</span>
                    <span *ngIf="selectedPaymentInsurance.code != 'INC'" class="text-value">{{ data.totalCreditCost | number: '1.2-2' | myCurrencyPipe: '€' }}</span>
                </div>
            </div>
            <div class="simulator-row">
                <span class="label">{{ totalAmountDue | translate }}</span>
                <div class="value">
                    <span *ngIf="selectedPaymentInsurance.code == 'INC'" class="text-value">{{ data.totalAmountDueInsurance | number: '1.2-2' | myCurrencyPipe: '€' }}</span>
                    <span *ngIf="selectedPaymentInsurance.code != 'INC'" class="text-value">{{ data.totalAmountDue | number: '1.2-2' | myCurrencyPipe: '€' }}</span>
                </div>
            </div>
            <div class="simulator-row">
                <span class="label">{{ installmentTotalGrossAmount | translate }}</span>
                <div class="value">
                    <span *ngIf="selectedPaymentInsurance.code == 'INC'" class="text-value">{{ data.financedAndInsuranceTotalGrossAmount | number: '1.2-2' | myCurrencyPipe: '€' }}</span>
                    <span *ngIf="selectedPaymentInsurance.code != 'INC'" class="text-value">{{ data.installmentTotalGrossAmount | number: '1.2-2' | myCurrencyPipe: '€' }}</span>
                </div>
            </div>
        </div>

        <div class="simulator-line"></div>

        <div *ngIf="data" class="installments">
            <div class="installments-row">
                <span *ngIf="selectedPaymentInsurance.code == 'INC'" class="label">{{ installmentAndInsuranceFirstGrossAmount | translate }}</span>
                <span *ngIf="selectedPaymentInsurance.code != 'INC'" class="label">{{ installmentFirstGrossAmount | translate }}</span>
                <div class="value">
                    <span *ngIf="selectedPaymentInsurance.code == 'INC'" class="text-value">{{ data.installmentAndInsuranceFirstGrossAmount | number: '1.2-2' | myCurrencyPipe: '€' }}</span>
                    <span *ngIf="selectedPaymentInsurance.code != 'INC'" class="text-value">{{ data.installmentFirstGrossAmount | number: '1.2-2' | myCurrencyPipe: '€' }}</span>
                </div>
            </div>
            <div class="installments-row">
                <span *ngIf="selectedPaymentInsurance.code == 'INC'" class="label">{{ installmentAndInsuranceLastGrossAmount | translate }}</span>
                <span *ngIf="selectedPaymentInsurance.code != 'INC'" class="label">{{ installmentLastGrossAmount | translate }}</span>
                <div class="value">
                    <span *ngIf="selectedPaymentInsurance.code == 'INC'" class="text-value">{{ data.installmentAndInsuranceLastGrossAmount | number: '1.2-2' | myCurrencyPipe: '€' }}</span>
                    <span *ngIf="selectedPaymentInsurance.code != 'INC'" class="text-value">{{ data.installmentLastGrossAmount | number: '1.2-2' | myCurrencyPipe: '€' }}</span>
                </div>
            </div>
        </div>

        <div *ngIf="data" class="legal-text">
            <div class="frame1">
                <!-- <span *ngIf="!isMultiCreditSelected" class="text"
                    >{{ legalText1 | translate }} {{ data.duration }} {{ legalText2 | translate }}
                    {{ data.installmentMonthlyGrossAmount | number: '1.2-2' | myCurrencyPipe: '€' }}
                    {{ legalText3 | translate }}
                    Jaguar Car Financial Services (pertencientes a Jaguar Car Group) {{ legalText4 | translate }} Banco Cetelem S.A.U. es válida hasta
                    el {{ today | date: 'dd/MM/yyyy' }}</span
                >

                <span *ngIf="isMultiCreditSelected" class="text"
                    >{{ legalText1 | translate }} {{ data.duration }} {{ legalText2 | translate }}
                    {{ data.installmentMonthlyGrossAmount | number: '1.2-2' | myCurrencyPipe: '€' }} {{ legalText6 | translate }}
                    {{ data.installmentLastGrossAmount | number: '1.2-2' | myCurrencyPipe: '€' }}
                    {{ legalText3 | translate }}
                    Jaguar Car Financial Services (pertencientes a Jaguar Car Group) {{ legalText4 | translate }} Banco Cetelem S.A.U. es válida hasta
                    el {{ today | date: 'dd/MM/yyyy' }}</span
                > -->

                <span class="text" > {{ legalText1 | translate }} {{ data.duration }} {{ legalText2 | translate }}</span>
                <span *ngIf="selectedPaymentInsurance.code == 'INC'" class="text" >
                    {{ data.installmentAndInsuranceTotalGrossAmount | number: '1.2-2' | myCurrencyPipe: '€' }}</span>
                <span *ngIf="selectedPaymentInsurance.code != 'INC'" class="text" >
                    {{ data.installmentMonthlyGrossAmount | number: '1.2-2' | myCurrencyPipe: '€' }}</span>
                <span *ngIf="isMultiCreditSelected && selectedPaymentInsurance.code == 'INC'" class="text" style="display: inline;">{{ legalText6 | translate }}
                    {{ data.installmentAndInsuranceLastGrossAmount | number: '1.2-2' | myCurrencyPipe: '€' }}</span>
                <span *ngIf="isMultiCreditSelected  && selectedPaymentInsurance.code != 'INC'" class="text" style="display: inline;">{{ legalText6 | translate }}
                    {{ data.installmentLastGrossAmount | number: '1.2-2' | myCurrencyPipe: '€' }}</span>
                <span class="text" style="display: inline;"> {{ legalText3 | translate }}
                    Jaguar Car Financial Services (pertencientes a Jaguar Car Group) {{ legalText4 | translate }} Banco Cetelem S.A.U. es válida hasta
                    el {{ today | date: 'dd/MM/yyyy' }}</span>
            </div>

            <div class="frame2">
                <span class="text"
                    >{{ legalText5 | translate }} {{ data.formalizationFee.percentage | number: '1.2-2' | myPercentPipe }}:
                    {{ data.formalizationFee.amount | number: '1.2-2' | myCurrencyPipe: '€' }}</span
                >
            </div>
        </div>
    </div>

    <div class="vertical-line"></div>

    <!--
 <p-scrollPanel [style]="{ width: '100%', height: '550px' }" class="p-scroll-panel" styleClass="disable-scroll">
 -->
    <!--
    <p-scrollPanel class="simulator-panel">
 -->

    <p-scrollPanel [style]="{ width: '100%', height: '690px' }" class="simulator-panel" styleClass="disable-scroll">
        <form class="form" [formGroup]="formGroup" (ngSubmit)="onSubmit(formGroup.value)">
            <span class="text-title">{{ modifyConditionsFinancing | translate }}</span>

            <div class="simulator">
                <div class="type-financiation">
                    <p-selectButton
                        id="typeFinancialProduct"
                        formControlName="typeFinancialProduct"
                        class="type-financiation-options"
                        [options]="financialProductOptions"
                        optionLabel="name"
                        optionValue="id"
                        (onOptionClick)="onChangeFinancialProduct($event)"
                    ></p-selectButton>

                    <div class="text-info">
                        <i class="ri-information-line text-info-icon"></i>
                        <span *ngIf="isMultiCreditSelected" class="text-info-label">{{ multiOptionCreditConditions | translate }}</span>
                        <span *ngIf="!isMultiCreditSelected" class="text-info-label">{{ classicCreditConditions | translate }}</span>
                    </div>
                </div>

                <div class="credit-duration">
                    <p-dropdown
                        id="duration"
                        formControlName="duration"
                        class="p-dropdown"
                        [options]="periods"
                        placeholder="{{ creditDuration | translate }}"
                        optionLabel="label"
                        inputId="float-label"
                        (onChange)="onChangeDurationFinancing($event)"
                    >
                        <ng-template pTemplate="selectedItem">
                            <div class="flex align-items-center gap-2" *ngIf="selectedDuration">
                                <span class="float-label-dropdown">{{ creditDuration | translate }}</span>

                                <div class="data-field-value-dropdown-item-selected">{{ selectedDuration.label }}</div>
                            </div>
                        </ng-template>
                        <ng-template let-duration pTemplate="item">
                            <div class="flex align-items-center gap-2">
                                <div class="selected-item-dropdown data-field-value-dropdown">
                                    {{ duration.label }}
                                    <i *ngIf="duration == selectedDuration" class="ri-check-line class-icono-component"></i>
                                </div>
                            </div>
                        </ng-template>
                    </p-dropdown>
                </div>

                <div class="sliders">
                    <div class="slider1">
                        <div class="slider1-row1">
                            <label class="label-left">{{ downPaymentGrossAmount | translate }} </label>

                            <div class="group-label-right ng-dirty ng-invalid">
                                <input
                                    id="downPaymentGrossAmount"
                                    type="text"
                                    pInputText
                                    formControlName="downPaymentGrossAmount"
                                    class="label-left w-full"
                                    (keyup)="onChangeDownPaymentGrossAmount($event)"
                                    required
                                />
                                <label for="downPaymentGrossAmount" class="label-right"> €</label>
                            </div>
                        </div>

                        <div class="slider1-content">
                            <p-slider
                                id="downPaymentGrossAmountSlider"
                                formControlName="downPaymentGrossAmountSlider"
                                [min]="downPaymentGrossAmountRangeMin"
                                [max]="downPaymentGrossAmountRangeMax"
                                [step]="500"
                                class="w-full"
                                (onChange)="onChangeDownPaymentGrossAmountSlider($event)"
                            ></p-slider>
                        </div>

                        <div class="slider1-row2">
                            <label class="label-left">{{ downPaymentGrossAmountRangeMin | number: '1.2-2' | myCurrencyPipe: '€' }}</label>
                            <label class="label-right">{{ downPaymentGrossAmountRangeMax | number: '1.2-2' | myCurrencyPipe: '€' }}</label>
                        </div>
                    </div>

                    <div *ngIf="isMultiCreditSelected" class="slider2">
                        <div class="slider2-row1">
                            <label for="annualMileage" class="label-left">{{ annualMileage | translate }} </label>
                            <label for="annualMileage" class="label-right"> {{ selectedAnnualMileage }} Km </label>
                        </div>
                        <div class="slider2-content">
                            <p-slider
                                id="annualMileageSlider"
                                formControlName="annualMileageSlider"
                                [min]="annualMileagesRangeMin"
                                [max]="annualMileagesRangeMax"
                                [step]="5000"
                                class="w-full"
                                (onChange)="onChangeAnnualMileageSlider($event)"
                            ></p-slider>
                        </div>
                        <div class="slider2-row2">
                            <label class="label-left">{{ annualMileagesRangeMin }} </label>
                            <label class="label-right">{{ annualMileagesRangeMax }} Km </label>
                        </div>
                    </div>
                </div>
            </div>

            <div class="line-simulator"></div>

            <div class="managemnet-costs-simulator">
                <div class="label-group">
                    <span class="text-paragraph-description">{{ formalisationCommission | translate }} </span>
                    <i
                        class="ri-information-line tooltip-class"
                        data-title="La comisión de formalización es el % que vas a pagar a la financiera por realizar una serie de gestiones administrativas para formalizar la operación. Es un porcentaje sobre el importe del préstamo."
                    ></i>
                </div>
                <div class="option-group">
                    <p-selectButton
                        id="commissionIncluded"
                        class="p-selectbutton"
                        [options]="commissionIncluded"
                        formControlName="commissionIncluded"
                        optionLabel="label"
                        optionValue="code"
                        (onOptionClick)="onChangeCommissionIncluded($event)"
                        [disabled]="true"
                    ></p-selectButton>
                </div>
            </div>

            <div class="line-simulator"></div>

            <div class="insurance-simulator">
                <div class="label-group">
                    <span class="text-paragraph-description">{{ paymentProtectionInsurance | translate }} </span>
                    <i
                        class="ri-information-line tooltip-class"
                        data-title="Hemos diseñado un seguro de protección de pagos que te cuida en caso de que se presente un imprevisto"
                    ></i>
                </div>

                <div class="option-group">
                    <p-selectButton
                        id="paymentInsurance"
                        class="p-selectbutton"
                        [options]="paymentInsurance"
                        formControlName="paymentInsurance"
                        optionLabel="label"
                        optionValue="code"
                        (onOptionClick)="onChangePaymentInsurance($event)"
                    ></p-selectButton>
                </div>
            </div>
        </form>
    </p-scrollPanel>

    <div class="simulator-actions">
        <button pripple="" class="button-secondary button-cancel" type="button" [disabled]="cancelButtonDisabled" (click)="onClicButtonCancel()">
            <span class="p-button-label-right">{{ cancelButton | translate }}</span>
        </button>

        <button pripple="" class="button-primary button-save" type="submit" [disabled]="saveButtonDisabled" (click)="onSubmit(formGroup.value)">
            <span class="p-button-label-left">{{ calculateButton | translate }}</span>
        </button>
    </div>

    <div class="flex close-cart-box">
        <button id="closeButton" class="button-close button-rounded" type="button" (click)="onClicButtonCancel()">
            <i class="ri-close-fill"></i>
        </button>
    </div>
</div>
